import { Component } from "@angular/core";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { NavController, NavParams, Platform } from "ionic-angular";
import { ConfigProvider } from "../../../providers/config/config";
import { AppVersion } from "@ionic-native/app-version";
import { HttpClient } from "@angular/common/http";
import { SettingsProvider } from "../../../providers/settings/settings";

/**
 * Generated class for the TextContactPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: "page-text-contact",
  templateUrl: "text-contact.html"
})
export class TextContactPage {
  contactUrl: string = "";
  buildInfo = {
    version: 1,
    lm: 0
  };
  pipeDateFormat = "dd.MM.yyyy";
  constructor(
    private platform: Platform,
    public navCtrl: NavController,
    public navParams: NavParams,
    private http: HttpClient,
    private iab: InAppBrowser,
    private config: ConfigProvider,
    private settingsService: SettingsProvider
  ) {
    this.platform.ready().then(() => {
      this.settingsService.getActiveDateFormat().then(async date => {
        this.pipeDateFormat = date.pipeFormat;
        this.contactUrl = "mailto:" + (await this.config.config).contact.url;
        this.http
          .get('assets/data/buildInfo.json')
          .toPromise()
          .then((values: any) => {
            this.buildInfo = values;
          })
          .catch(error => {
            throw 'cannot get buildInfo.json';
          });
      });
      // this.appVersionService.getVersionCode().then(ver => {
      //   this.appVersion = ver + "";
      // });
    });
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad TextContactPage");
  }

  sendMail() {
    let browser = this.iab.create(this.contactUrl);
    browser.show();
  }
}



// WEBPACK FOOTER //
// /src/pages/textPages/text-contact/text-contact.ts